import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateTimePipe } from './pipes/datetime.pipe';
import { ArrayIncludesPipe } from './pipes/arrayIncludes.pipe';
import { LocaleTranslationPipe } from './pipes/locale-translation.pipe';
import { ObjectComparatorPipe } from './pipes/object-comparator.pipe';
import { GroupByPipe } from './pipes/group-by.pipe';
import { PercentagePipe } from './pipes/percentage.pipe';

@NgModule({
  imports: [CommonModule, GroupByPipe, ArrayIncludesPipe, PercentagePipe],
  declarations: [DateTimePipe, LocaleTranslationPipe, ObjectComparatorPipe],
  exports: [DateTimePipe, LocaleTranslationPipe, ObjectComparatorPipe, GroupByPipe, ArrayIncludesPipe, PercentagePipe],
})
export class SharedUtilPipesModule {}
